import React, { SVGProps } from 'react';

const BackArrowFull = (props: SVGProps<SVGSVGElement>) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11.0833 7.02221L2.33325 7.02222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.26127 3.50005L1.75011 7.01121L5.26127 10.5224"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BackArrowFull;
